import { render, staticRenderFns } from "./BroadcastHistory.vue?vue&type=template&id=36dc1359"
import script from "./BroadcastHistory.vue?vue&type=script&lang=js"
export * from "./BroadcastHistory.vue?vue&type=script&lang=js"
import style0 from "./BroadcastHistory.vue?vue&type=style&index=0&id=36dc1359&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports